import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const toneMap = {
  success: { bg: 'rgba(40, 167, 69, 0.12)', color: '#1B7A34' },
  danger: { bg: 'rgba(255, 21, 42, 0.12)', color: '#C41022' },
  warning: { bg: 'rgba(255, 187, 51, 0.22)', color: '#9A6B00' },
  dark: { bg: 'rgba(32, 16, 48, 0.12)', color: '#201030' },
  primary: { bg: 'rgba(255, 21, 42, 0.12)', color: '#C41022' },
  info: { bg: 'rgba(44, 168, 255, 0.14)', color: '#0B6FAE' },
  secondary: { bg: 'rgba(107, 114, 128, 0.14)', color: '#4B5563' }
}

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.28rem 0.7rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  background: ${props => (toneMap[props.tone] || toneMap.secondary).bg};
  color: ${props => (toneMap[props.tone] || toneMap.secondary).color};
`

const StatusPill = ({ tone, children, className }) => (
  <Pill tone={tone} className={className}>{children}</Pill>
)

StatusPill.propTypes = {
  tone: PropTypes.oneOf(['success', 'danger', 'warning', 'dark', 'primary', 'info', 'secondary']),
  children: PropTypes.node,
  className: PropTypes.string
}

StatusPill.defaultProps = {
  tone: 'secondary',
  className: ''
}

export default StatusPill
